$( '#AddToCartForm' ).on( 'submit', function( e ) {
  e.preventDefault();

  $.ajax ({
    url       : '/cart/add.js',
    type      :	'POST',
    async     : false,
    data      :	$( this ).serialize(),
    dataType  :	'json',
    success   :	function( response ) {
      UIkit.offcanvas('#cart-offcanvas').show();
    },
    error     : function( err ) {
      UIkit.notification({
        message : err.responseJSON.description,
        status  : 'danger',
        pos     : 'bottom-center',
        timeout : 4000
      });
    },
    cache     : false
  });
});

if ( $( '.product-gift' ).length ) {
  $( 'input[type=radio][name=id]' ).on( 'change', function() {
    var amnt = $(this).attr( 'data-title' );
    $( '#amout-price' ).html( amnt );
  } );
} else {
  $( 'input[type=radio][name=id]' ).on( 'change', function() {
    var
    price     = $( this ).siblings( '.variant-price' ).html(),
    available = $( this ).attr( 'data-available' );

    $( 'h3.product-price' ).html( price );

    if ( available === 'false' ) {
      $( 'button#AddToCart' ).attr( 'disabled', 'disabled' );
    } else {
      $( 'button#AddToCart' ).removeAttr( 'disabled' );
    }
  } );
};